import { render, staticRenderFns } from "./chatArea.vue?vue&type=template&id=0134f3ed"
import script from "./chatArea.vue?vue&type=script&lang=js"
export * from "./chatArea.vue?vue&type=script&lang=js"
import style0 from "./chatArea.vue?vue&type=style&index=0&id=0134f3ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports